// Used to show the different tiers: basic, premium etc. on mobile
import Box from "@mui/material/Box";
import Space from "../../../../Common/Space";
import {Checkbox, useTheme} from "@mui/material";
import Typography from "@mui/material/Typography";
import Column from "../../../../Common/Column";

export const TierRow = ({tier, checked, onClick, sx}) => {
    const theme = useTheme();
    const showDiscount = tier.discount > 0;

    return <Column
        sx={{
            cursor: "pointer",
            backgroundColor: tier.color,
        }}
        onClick={tier.disabled ? () => {} : onClick}
    >
        <Box
            sx={{
                display: "flex",
                justifyContent: "space-between",
                padding: "10px",
                opacity: tier.disabled ? "0.5" : "1",
                pointerEvents: tier.disabled ? "none" : "auto",
            }}
        >
            <Box sx={{
                display: "flex",
                alignItems: "center",
            }}>
                <Checkbox
                    sx={{height: "fit-content"}}
                    checked={checked}
                />
                <Space width="5px"/>
                <Box>
                    <Typography sx={{fontWeight: "bold"}}>
                        {tier.name.toUpperFirst()}
                    </Typography>

                    {tier.boost > 1 && (
                        <Typography
                            sx={{color: theme.palette.grey["700"]}}
                        >
                            {"• " + tier.boost + "x visninger"}
                        </Typography>
                    )}

                    {tier.features.map((feature, index) => {
                        return <Typography
                            sx={{color: theme.palette.grey["700"]}}
                        >
                            {"• " + feature.description}
                        </Typography>
                    }, "")}

                </Box>
            </Box>
            <Space width="25px"/>
            <Box>
                {showDiscount && (
                    <Typography sx={{
                        textDecoration: "line-through",
                    }}>
                        {tier.originalPrice} kr.
                    </Typography>
                )}
                <Typography
                    sx={{
                        whiteSpace: "nowrap",
                        fontWeight: "bold"
                    }}>{tier.paid ? "Betalt" : `${tier.price} kr.`}
                </Typography>
            </Box>
        </Box>
    </Column>
}